import * as bi from 'react-bootstrap-icons';
import { IClientPassengerBrief } from '@bustickus/models-client';
import { Box, Flex } from 'components';
import { Icon } from 'shared/components';
import { numberToTwoDigitString } from 'common/helpers';
import './style.scss';
import { PassengerDocuments } from './components';

interface IProps {
  passenger: IClientPassengerBrief;
  onClick: () => void;
}

function PassengerCard(props: IProps) {
  const passengerAnyDocument =
    props.passenger.passport != null || props.passenger.foreignPassport != null || props.passenger.visas.length > 0;

  return (
    <Box
      padding={10}
      variant='darker'
      className='passenger-card-0hDu'
      onClick={props.onClick}
    >
      <Flex
        direction='column'
        gap={20}
      >
        <Flex direction='column'>
          <Flex
            className='passenger-name-97QE'
            gap={5}
          >
            <Icon color='red'>
              <bi.Person />
            </Icon>
            <b>{props.passenger.name}</b>
          </Flex>
          <Flex
            className='passenger-birth-date-61SJ'
            gap={5}
          >
            <span>Дата рождения:</span>
            <span>{formatDate(new Date(props.passenger.birthDate))}</span>
            <Icon color='red'>
              {props.passenger.gender === 'female' && <bi.GenderFemale />}
              {props.passenger.gender === 'male' && <bi.GenderMale />}
            </Icon>
          </Flex>
        </Flex>

        {passengerAnyDocument && <PassengerDocuments passenger={props.passenger} />}
      </Flex>
    </Box>
  );
}

function formatDate(date: Date): string {
  const day = numberToTwoDigitString(date.getDate());
  const month = numberToTwoDigitString(date.getMonth() + 1);
  const year = numberToTwoDigitString(date.getFullYear());
  return `${day}.${month}.${year}`;
}

export default PassengerCard;
